import { render, staticRenderFns } from "./companyOchart.vue?vue&type=template&id=3806bcf4&scoped=true"
import script from "./companyOchart.vue?vue&type=script&lang=js"
export * from "./companyOchart.vue?vue&type=script&lang=js"
import style0 from "../../statistics/css/companyOchart.css?vue&type=style&index=0&id=3806bcf4&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3806bcf4",
  null
  
)

export default component.exports